@switch (shape()) {
	@case ('film') {
		<div
			class="aspect-square w-[100cqw] md:aspect-film md:h-100 md:w-auto lg:h-120 2xl:h-140"
		>
			<vp-image
				[image]="{
					src: image().src,
					altText: image().alt,
					width: 1200,
					height: 800,
				}"
				class="block size-full"
				className="size-full"
				sizes="auto, (min-width: 1536px) 840px, (min-width: 1024px) 720px, (min-width: 768px) 600px, 100vw"
			/>
		</div>
	}
	@case ('portrait') {
		<div
			class="aspect-square w-[100cqw] md:aspect-portrait md:h-100 md:w-auto lg:h-120 2xl:h-140"
		>
			<vp-image
				[image]="{
					src: image().src,
					altText: image().alt,
					width: 900,
					height: 1200,
				}"
				class="block size-full"
				className="size-full"
				sizes="auto, (min-width: 1536px) 420px, (min-width: 1024px) 360px, (min-width: 768px) 300px, 100vw"
			/>
		</div>
	}
	@default {
		<div
			class="aspect-square w-[100cqw] md:h-100 md:w-auto lg:h-120 2xl:h-140"
		>
			<vp-image
				[image]="{
					src: image().src,
					altText: image().alt,
					width: 1200,
					height: 1200,
				}"
				class="block size-full"
				className="size-full"
				sizes="auto, (min-width: 1536px) 560px, (min-width: 1024px) 480px, (min-width: 768px) 400px, 100vw"
			/>
		</div>
	}
}
